/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SearchResources200ResponseTablesInner } from '../models/SearchResources200ResponseTablesInner';

export class SearchResources200Response {
  /**
  * Found resources grouped by resource_id
  */
  'tables'?: Array<SearchResources200ResponseTablesInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tables",
      "baseName": "tables",
      "type": "Array<SearchResources200ResponseTablesInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResources200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

